import React, { useEffect } from 'react';
import { Player } from 'video-react';
import 'video-react/dist/video-react.css';
import { Helmet } from 'react-helmet-async';
import { Youtube } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function VideoGallery() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="vj-video-gallery-page py-5">
      <Helmet>
        <title>Video Gallery - Vidyajyoti College of Theology</title>
        <meta name="description" content="Watch documentary features, theological conferences, and student reflections from Vidyajyoti College of Theology." />
      </Helmet>

      <div className="container">
        {/* Header */}
        <div className="text-center mx-auto pb-4" style={{ maxWidth: '700px' }}>
          <span className="text-burgundy fw-bold text-uppercase small" style={{ letterSpacing: '0.1em' }}>
            MULTIMEDIA & RECORDINGS
          </span>
          <h1 className="vj-card-title display-6 fw-bold mt-1 text-dark-main">
            Campus Video Gallery
          </h1>
          <p className="text-muted mt-2">
            Documentaries, student theological forums, lectures, and event highlights.
          </p>
          <div className="mx-auto mt-2" style={{ width: '60px', height: '3px', background: '#79031d', borderRadius: '2px' }} />
        </div>

        {/* Video Feature Card */}
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="vj-modern-card p-3 p-md-4">
              <div className="rounded-4 overflow-hidden shadow-sm bg-black mb-3">
                <Player playsInline>
                  <source src="https://s3.ap-south-1.amazonaws.com/images.vidyajyoticollege.in/videos/gallery/TCT.mp4" />
                </Player>
              </div>

              <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3 pt-2">
                <div>
                  <h4 className="fw-bold text-dark mb-1">Towards Contextual Theologizing (TCT)</h4>
                  <p className="text-muted small mb-0">
                    A visual documentary on the mission, theological reflections, and apostolic fieldwork of Vidyajyoti College.
                  </p>
                </div>
                <Link to="/publications/youtube" className="vj-btn-primary flex-shrink-0">
                  <Youtube size={16} /> More on YouTube
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
